import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Radar, Mail, Activity } from 'lucide-react';
import AudienciasList from '../components/audiencias/AudienciasList';

export default function AudienciasPage() {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200 px-6 py-3 flex items-center gap-4 sticky top-0 z-10">
        <Link to="/" className="text-sm text-slate-600 hover:text-slate-900 flex items-center gap-1">
          <ArrowLeft size={14} /> Dashboard
        </Link>
        <div className="border-l border-slate-200 pl-4 flex-1">
          <h1 className="text-base font-semibold text-slate-800 flex items-center gap-2">
            <Radar size={16} className="text-violet-600" /> Audiências — Discovery Apollo
          </h1>
          <p className="text-[11px] text-slate-500">Queries Apollo nomeadas: people + companies. Templates para iniciar, execução sob demanda, materialização com compliance.</p>
        </div>
        <Link to="/ai-health/email-coverage" className="text-xs text-teal-700 hover:text-teal-900 flex items-center gap-1"><Mail size={12} /> Coverage</Link>
        <Link to="/ai-health/gmail-sync" className="text-xs text-amber-700 hover:text-amber-900 flex items-center gap-1"><Activity size={12} /> Sync Health</Link>
      </header>

      <main className="p-6 max-w-6xl mx-auto">
        <AudienciasList />
      </main>
    </div>
  );
}
